// Import Enums
import { DisplayModeEnum } from 'enums';
// Import Types
import { PreviewStyles, WhatsAppPreviewTheme } from './types';

export const HEADER_MEDIA_PLACEHOLDER_BACKGROUND =
    'repeating-conic-gradient(#e0e0e0 0% 25%, #f5f5f5 0% 50%) 50% / 16px 16px';

export const DISPLAY_MODE_THEMES: Record<DisplayModeEnum, WhatsAppPreviewTheme> = {
    [DisplayModeEnum.LightMode]: {
        wrapperBackground: '#e5ddd5',
        templateBackground: '#ffffff',
        textColor: '#3b4a54',
        footerTimestampColor: '#667781',
        imageBorderColor: '#e0e0e0',
        mediaLabelColor: '#8696a0',
        buttonColor: '#00a884',
        buttonBackground: '#f0f2f5',
    },
    [DisplayModeEnum.DarkMode]: {
        wrapperBackground: '#2a2f38',
        templateBackground: '#3f4b5b',
        textColor: '#ffffff',
        footerTimestampColor: '#a3aab1',
        imageBorderColor: '#0c455c',
        mediaLabelColor: '#8696a0',
        buttonColor: '#00a884',
        buttonBackground: '#2a3642',
    },
};

export const getPreviewStyles = (theme: WhatsAppPreviewTheme): PreviewStyles => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        width: '80%',
        height: '100%',
        minHeight: '120px',
        padding: '1rem',
        backgroundColor: theme.wrapperBackground,
        borderRadius: '8px',
    },
    template: {
        position: 'relative',
        maxWidth: '320px',
        width: '100%',
        height: 'fit-content',
        backgroundColor: theme.templateBackground,
        borderRadius: '8px',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
    },
    headerText: {
        padding: '12px 12px 8px',
        fontSize: '15px',
        fontWeight: 600,
        color: theme.textColor,
        wordBreak: 'break-word',
        lineHeight: 1.4,
    },
    headerMediaPlaceholder: {
        width: '100%',
        minHeight: '160px',
        background: HEADER_MEDIA_PLACEHOLDER_BACKGROUND,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${theme.imageBorderColor}`,
    },
    headerImage: {
        width: '100%',
        maxHeight: '240px',
        objectFit: 'cover',
        display: 'block',
    },
    mediaLabel: {
        fontSize: '12px',
        color: theme.mediaLabelColor,
        textTransform: 'uppercase',
    },
    bodyText: {
        padding: '8px 12px 12px',
        fontSize: '14px',
        color: theme.textColor,
        wordBreak: 'break-word',
        lineHeight: 1.4,
        whiteSpace: 'pre-wrap',
    },
    footerText: {
        padding: '4px 12px 8px',
        fontSize: '12px',
        color: theme.footerTimestampColor,
        wordBreak: 'break-word',
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        padding: '4px 12px 12px',
    },
    buttonItem: {
        padding: '10px 12px',
        fontSize: '14px',
        color: theme.buttonColor,
        textAlign: 'center',
        backgroundColor: theme.buttonBackground,
        borderRadius: '4px',
    },
    timestamp: {
        padding: '2px 12px 8px',
        fontSize: '11px',
        color: theme.footerTimestampColor,
        textAlign: 'right',
    },
    loadingEmpty: {
        padding: '2rem',
        textAlign: 'center',
        color: theme.textColor,
    },
});
